import { HTTP } from '@/services/axios';

export async function getLevels({filterText,orderCol,orderSort,page,records}){
    let result = {};
    
    await HTTP.get('/app/core/Level/getLevelList.php',{
        params:{
            filterText,
            orderCol,
            orderSort,
            page,
            records
        }
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getLevel({levelId}){
    let result = {};
    
    await HTTP({
        method: 'get',
        url: `/app/core/Level/getLevelData.php?levelId=${levelId}`,
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });
    return result;
}


export async function unlockLevel({levelId}){
    let result = {};

    var data = {'myRecordID':levelId};
    
    await HTTP({
        method: 'patch',
        url: '/app/core/Level/controlLevelUnlock.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}



export async function createLevel({data}){
    let result = {};

    await HTTP({
        method: 'post',
        url: '/app/core/Level/controlLevelSave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function saveLevel({data}){
    let result = {};

    await HTTP({
        method: 'put',
        url: '/app/core/Level/controlLevelSave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function deleteLevel({data}){
    let result = {};

    await HTTP({
        method: 'delete',
        url: '/app/core/Level/controlLevelDelete.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

//froups to level
export async function getGroupsToLevel({levelId}){
    let result = {};

    await HTTP({
        method: 'get',
        url: `/app/core/Level/getLevelGroupData.php?levelId=${levelId}`
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function saveGroupsToLevel({groups,levelId}){
    let result = {};

    var data = {'levelId':levelId,'myGroups':groups};
    
    await HTTP({
        method: 'patch',
        url: '/app/core/Level/controlLevelGroupSave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}